export const getSearchString = (addressModel) => {
    if (!addressModel) {
        return '';
    }

    const { street, suburb, state, country } = addressModel;
    const searchStrings = [street, suburb, state, country];
    
    return searchStrings.filter(x => x).join(', ');
}